import { createSlice } from "@reduxjs/toolkit";
import { getClientToken } from "../../helper/clientAuth";

const storedToken = getClientToken();

const initialState = {
  isAuthenticated: Boolean(storedToken),
  token: storedToken,
  user: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.user = action.payload.user || null;
    },

    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
